export const breadcrumb = (path, match, rootIsList = true) => {
  const paths = path.reduce((acc, item, index) => {
    // If this is the first item, we want to set it as the root of the resource
    if (path[path.length - 1] === 'list') {
      if (acc.length === 0) {
        acc.push({ breadcrumbPath: `/${item}`, label: item })
        return acc
      }
    } else {
      if (item && acc.length === 0) {
        acc.push({ breadcrumbPath: `/${item}`, label: item })
      }

      if (item && acc.length > 0 && index >= 1) {
        // If we have params,
        if (match) {
          // Lets check for an id property...
          if (match.params && match.params.id) {
            // If it has one, this is an update route for the resource...
            acc.push({
              breadcrumbPath: `${acc[acc.length - 1].breadcrumbPath}/${match.params.id}`,
              label: `update${acc[0].label.charAt(0).toUpperCase() + acc[0].label.slice(1)}`
            })
          } else {
            // And if it's not an update route, we only add the path item to the array.
            acc.push({
              breadcrumbPath: `${acc[acc.length - 1].breadcrumbPath}/${item}`,
              label: `${item}${acc[0].label.charAt(0).toUpperCase() + acc[0].label.slice(1)}`
            })
          }
        }
      }
    }

    return acc
  }, [])
  if (rootIsList) {
    paths[0] = {
      breadcrumbPath: `${paths[0].breadcrumbPath}/list`,
      label: paths[0].label
    }
  }

  return paths
}
